export default "__VITE_ASSET__0b30581c__"